export function maskDate(date) {
  const inputDate = new Date(date);
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);
  const inputDateString = inputDate.toLocaleDateString();
  const todayString = today.toLocaleDateString();
  const yesterdayString = yesterday.toLocaleDateString();
  if (inputDateString === todayString) return 'Hoje';
  if (inputDateString === yesterdayString) return 'Ontem';
  return inputDateString;
}